/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './assignModerator.defs.js'
export { main as default } from './assignModerator.defs.js'
